import React from 'react';
import { Card as MuiCard, styled } from '@mui/material';

// Современный стиль карточки
const StyledCard = styled(MuiCard)(
  ({ theme, elevation = 0, clickable = false, bgcolor }) => ({
    borderRadius: '16px',
    boxShadow:
      elevation === 0
        ? 'none'
        : `0 10px 30px ${theme.palette.common.black}05, 0 1px 4px ${theme.palette.common.black}04`,
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    background: bgcolor || theme.palette.background.paper,
    color: theme.palette.text.primary,
    padding: '20px',
    ...(clickable && {
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: `0 20px 40px ${theme.palette.common.black}05, 0 3px 8px ${theme.palette.common.black}06`,
      },
    }),
    [theme.breakpoints.down('sm')]: {
      padding: '14px',
    },
  })
);

const Card = ({ children, clickable = false, ...props }) => {
  return (
    <StyledCard clickable={clickable} {...props}>
      {children}
    </StyledCard>
  );
};

export default Card;
